
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d58Kh", function(module, exports) {

$parcel$export(module.exports, "EditorContentClassificationTag", () => $e5b90af40522fc78$export$5b4b298e9ab4c624);
/* EditorContentClassificationTag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $ipPpS = parcelRequire("ipPpS");

var $2nPZH = parcelRequire("2nPZH");

var $9hlns = parcelRequire("9hlns");

var $cd3ua = parcelRequire("cd3ua");
var $6VQXY = parcelRequire("6VQXY");

var $dIouf = parcelRequire("dIouf");

var $gqqjz = parcelRequire("gqqjz");

var $9wGTI = parcelRequire("9wGTI");

var $in5LX = parcelRequire("in5LX");

var $gfkT8 = parcelRequire("gfkT8");

var $huR5x = parcelRequire("huR5x");

var $cwD0R = parcelRequire("cwD0R");

var $fGQzQ = parcelRequire("fGQzQ");

var $l4l51 = parcelRequire("l4l51");

var $4UY5S = parcelRequire("4UY5S");
const $e5b90af40522fc78$var$TagWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInEditorTitle: isInEditorTitle, isTitleCenterAligned: isTitleCenterAligned, shouldChangeTagPlacement: shouldChangeTagPlacement, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1s8bfdt": (0, $iAWao.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            __cmplp.isInEditorTitle && __cmplp.isTitleCenterAligned ? 'center' : 'initial'),
            "--_1ldf4eq": (0, $iAWao.default)(__cmplp.shouldChangeTagPlacement ? 'absolute' : 'initial'),
            "--_1v4akxz": (0, $iAWao.default)(__cmplp.shouldChangeTagPlacement ? '-33px' : 'unset'),
            "--_11fg50p": (0, $iAWao.default)(__cmplp.shouldChangeTagPlacement ? '5px' : 'unset')
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulp12x7 _1e0c1txw _4cvr1h6o _1bah1jcu _kqswikkd _154i1azk _1ltvudut",
            __cmplp.className
        ])
    });
});
const $e5b90af40522fc78$var$messages = (0, $2nPZH.defineMessages)({
    errorTitle: {
        id: "data-classification.content-classification.error-flag.title",
        defaultMessage: "Update to classification failed to save"
    },
    errorDescription: {
        id: "data-classification.content-classification.error-flag.description",
        defaultMessage: "Please try again."
    }
});
// Note: To be used only with fg('dlp_cc-minimize-classifications-queries') enabled
const $e5b90af40522fc78$var$LazierEditPopup = (props)=>{
    const { selectedOption: selectedOptionProp, onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, isDisabled: isDisabledProp, loading: loadingProp, spaceKey: spaceKey } = props;
    const { defaultClassification: spaceDefaultClassification, classificationLevels: classificationLevels, getClassificationLevelFromId: getClassificationLevelFromId, expectedError: expectedError, loading: spaceAndDefaultLoading } = (0, $cwD0R.useDefaultAndSpaceClassificationLevels)({
        spaceKey: spaceKey
    });
    const { defaultClassificationOption: defaultClassificationOption, error: defaultClassificationError, loading: orgDefaultLoading } = (0, $l4l51.useComputeDefaultClassificationDropdownOption)({
        spaceDefaultClassificationLevel: spaceDefaultClassification,
        getClassificationLevelFromId: getClassificationLevelFromId
    });
    const allClassificationLevels = [
        ...(0, $huR5x.getAllClassificationLevels)(classificationLevels),
        defaultClassificationOption
    ];
    const selectedOption = selectedOptionProp || defaultClassificationOption;
    const hasError = !!expectedError || !!defaultClassificationError;
    const combinedLoadingCondition = loadingProp || spaceAndDefaultLoading || orgDefaultLoading;
    if (combinedLoadingCondition) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cd3ua.EditPopup), {
        options: allClassificationLevels,
        selectedOption: selectedOption || undefined,
        onEditCancel: onEditCancel,
        onEditSubmit: onEditSubmit,
        errorMessage: hasError ? 'Unable to load classification. Try again.' : undefined,
        loading: combinedLoadingCondition,
        isDisabled: isDisabledProp || combinedLoadingCondition
    });
};
// Responsible for all editor-specific classification functionality (i.e. function for rendering Select Classification popup component & rendering error flag)
const $e5b90af40522fc78$var$EditorContentClassificationTagComponent = ({ contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, isEditMode: isEditMode, customSitesTitleComponent: customSitesTitleComponent = false, spaceKey: spaceKey, isInEditorTitle: isInEditorTitle = false, isTitleCenterAligned: isTitleCenterAligned = false, userOffline: userOffline = false })=>{
    const { classification: currentClassification, spaceClassification: spaceClassification, flagStatus: flagStatus, shouldDisplayClassification: shouldDisplayClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, getClassificationLevelFromId: getClassificationLevelFromId } = contentClassificationMetadata;
    const spaceClassificationMetadata = (0, $cwD0R.useDefaultAndSpaceClassificationLevels)({
        spaceKey: spaceKey,
        skipQuery: (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')
    });
    const { defaultClassificationOption: defaultOptionFromHook, error: classificationOptionError } = (0, $l4l51.useComputeDefaultClassificationDropdownOption)({
        getClassificationLevelFromId: getClassificationLevelFromId,
        spaceDefaultClassificationLevel: spaceClassification,
        skipQuery: (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')
    });
    const defaultClassificationOption = (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries') ? undefined : defaultOptionFromHook;
    const selectedOption = (0, $gwFzn.useMemo)(()=>{
        if (!spaceDefaultIsOverridden) return defaultClassificationOption;
        else return currentClassification;
    }, [
        currentClassification,
        spaceDefaultIsOverridden,
        defaultClassificationOption
    ]);
    const allClassificationLevels = !!spaceClassificationMetadata && defaultClassificationOption ? [
        ...(0, $huR5x.getAllClassificationLevels)(spaceClassificationMetadata?.classificationLevels),
        defaultClassificationOption
    ] : [];
    const handleEditSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const onEditSubmit = (classification, closePopup)=>{
        handleEditSubmit(classification);
        closePopup();
    };
    if (!shouldDisplayClassification || !currentClassification) return null;
    const getEditPopup = (closePopup)=>{
        if ((0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e5b90af40522fc78$var$LazierEditPopup, {
            spaceKey: spaceKey,
            selectedOption: selectedOption,
            onEditCancel: closePopup,
            onEditSubmit: (classification)=>{
                onEditSubmit(classification, closePopup);
            },
            loading: flagStatus === (0, $in5LX.FlagStatus).LOADING,
            isDisabled: userOffline
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cd3ua.EditPopup), {
            options: allClassificationLevels,
            selectedOption: selectedOption || undefined,
            onEditCancel: closePopup,
            onEditSubmit: (classification)=>{
                onEditSubmit(classification, closePopup);
            },
            errorMessage: spaceClassificationMetadata?.expectedError ? 'Unable to load classification. Try again.' : undefined,
            loading: flagStatus === (0, $in5LX.FlagStatus).LOADING,
            isDisabled: userOffline
        });
    };
    const renderPopupComponent = (closePopup)=>isEditMode ? getEditPopup(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6VQXY.ReadPopup), {
            name: currentClassification.name,
            guideline: currentClassification.guideline
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e5b90af40522fc78$var$TagWrapper, {
        isInEditorTitle: isInEditorTitle,
        isTitleCenterAligned: isTitleCenterAligned,
        shouldChangeTagPlacement: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4UY5S.ContentClassificationTag), {
        contentId: contentId,
        contentType: contentType || null,
        customSitesTitleComponent: customSitesTitleComponent,
        contentClassificationMetadata: contentClassificationMetadata,
        renderPopupComponent: userOffline ? undefined : renderPopupComponent,
        isEditMode: true
    }), flagStatus === (0, $in5LX.FlagStatus).LOADING && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "small"
    }), classificationOptionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: classificationOptionError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: $e5b90af40522fc78$var$messages.errorTitle,
            description: $e5b90af40522fc78$var$messages.errorDescription,
            type: "warning",
            showRefresh: false
        })));
};
const $e5b90af40522fc78$var$EditorContentClassificationTagGetter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e5b90af40522fc78$var$EditorContentClassificationTagComponent, props);
};
const $e5b90af40522fc78$var$EditorContentClassificationTagWithErrorBoundary = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).DLP
})($e5b90af40522fc78$var$EditorContentClassificationTagGetter);
const $e5b90af40522fc78$export$5b4b298e9ab4c624 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e5b90af40522fc78$var$EditorContentClassificationTagWithErrorBoundary, props);

});
parcelRegister("6VQXY", function(module, exports) {

$parcel$export(module.exports, "ReadPopup", () => $1b0493e379fac10b$export$6d6315f08f93adaa);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $dokWT = parcelRequire("dokWT");

var $1HYxw = parcelRequire("1HYxw");
const $1b0493e379fac10b$var$containerStyles = (0, $ecnYn.xcss)({
    width: '330px'
});
const $1b0493e379fac10b$export$6d6315f08f93adaa = ({ name: name, guideline: guideline, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onChangeLevelClick: onChangeLevelClick })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        padding: "space.250",
        xcss: $1b0493e379fac10b$var$containerStyles,
        role: "dialog",
        "aria-labelledby": "data-classification-read-content-name",
        "aria-describedby": "data-classification-read-content-guideline",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dokWT.ClassificationView), {
                name: name,
                guideline: guideline,
                guidelineRepresentation: guidelineRepresentation
            }),
            Boolean(onChangeLevelClick) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                paddingBlockStart: "space.200",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
                    justifyContent: "end",
                    gap: "space.100",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        onClick: onChangeLevelClick,
                        children: intl.formatMessage((0, $1HYxw.messages).changeLevel)
                    })
                })
            })
        ]
    });
};

});

parcelRegister("gfkT8", function(module, exports) {

$parcel$export(module.exports, "SaveFlag", () => $4ebf6b4d55a3b532$export$ac7557ff3627d244);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $dIouf = parcelRequire("dIouf");

var $1cYlh = parcelRequire("1cYlh");
const $4ebf6b4d55a3b532$var$actionMessage = (0, $2nPZH.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $gwFzn.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);

});



//# sourceMappingURL=EditorContentClassificationTag.92f02ff5.js.map
